import { ObservableArray, View, ViewModel } from "binder";
import { ClassGenerator, CompiledClass } from "./classGenerator";
import { DataModelParser } from "./dataModelParser";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { getAsNumber } from "src/uicomponents/components/utilities";

export class DataModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.classes = ObservableArray.create<DataModelClass>();
    }

    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    private _classesContainer : CompiledClass;
    
    generateClasses(parent:ViewModel,withCodeExecution:boolean=true) : ViewModel{
        let generator = new ClassGenerator();
        if(this._classesContainer==null){
            this._classesContainer = generator.generateClasses(this,this,withCodeExecution);
        }
        let result = this._classesContainer.__CreateNewInstance__(parent);
        return result;
    }
    Parse(json: any) {
        new DataModelParser(this).Parse(json);
    }

    public GetCompliledClass(dataModelClass : DataModelClass) : CompiledClass{
        return this.GetCompliledClassByName(dataModelClass.name);
    }

    GetCompliledClassByName(typeName: string) :CompiledClass {
        return this._classesContainer[typeName];
    }
    
}

export class DataModelClass extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.members = ObservableArray.create<Member>();
    }
    public set dataModel(v: DataModel) { this._dataModel = v; } public get dataModel(): DataModel { return this._dataModel;} private _dataModel: DataModel;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set members(v: ObservableArray<Member>) { this._members = v; } public get members(): ObservableArray<Member> { return this._members;} private _members: ObservableArray<Member>;
    
    public GetProperties() : ClassProperty[]{
        return this.members.filter(x=>x instanceof ClassProperty).map(x=><ClassProperty><any>x);
    }
    public GetMethods() : ClassFunction[]{
        return this.members.filter(x=>x instanceof ClassFunction).map(x=><ClassFunction><any>x);
    }
    addMember(property: Member) {
        this.members.push(property);
    }
    createInstance(parent:ViewModel) : CompiledClass{
        let compiledClass = this.dataModel.GetCompliledClass(this);
        return compiledClass.__CreateNewInstance__(parent);
    }
}

export class Member extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}
export class ClassProperty extends Member{
    public set propertyType(v: PropertyType) { this._propertyType = v; } public get propertyType(): PropertyType { return this._propertyType;} private _propertyType: PropertyType;
    public set default(v: any) { this._default = v; } public get default(): any { return this._default;} private _default: any;
    public set shallInitialize(v: boolean) { this._shallInitialize = v; } public get shallInitialize(): boolean { return this._shallInitialize;} private _shallInitialize: boolean;
    public set preBody(v: any) { this._preBody = v; } public get preBody(): any { return this._preBody;} private _preBody: any;
    public set postBody(v: any) { this._postBody = v; } public get postBody(): any { return this._postBody;} private _postBody: any;
    public set nullAllowanceBody(v: any) { this._nullAllowanceBody = v; } public get nullAllowanceBody(): any { return this._nullAllowanceBody;} private _nullAllowanceBody: any;
        
} 



export class ClassFunction extends Member{
    
    constructor(parent:ViewModel) {
        super(parent);
        this.arguments = ObservableArray.create<FunctionArgument>();    
    }
    public set isAsync(v: boolean) { this._isAsync = v; } public get isAsync(): boolean { return this._isAsync;} private _isAsync: boolean;
    public set returnType(v: PropertyType) { this._returnType = v; } public get returnType(): PropertyType { return this._returnType;} private _returnType: PropertyType;
    public set arguments(v: ObservableArray<FunctionArgument>) { this._arguments = v; } public get arguments(): ObservableArray<FunctionArgument> { return this._arguments;} private _arguments: ObservableArray<FunctionArgument>;
    public set body(v: any) { this._body = v; } public get body(): any { return this._body;} private _body: any;
} 

export class FunctionArgument extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set type(v: PropertyType) { this._type = v; } public get type(): PropertyType { return this._type;} private _type: PropertyType;
}
export class ClassEvent extends Member{

} 


export abstract class PropertyType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public abstract Accept(visitor:IPropertyTypeVisitor,parameter):any;
    public isSameTypeAs(propertyType:PropertyType){
        return this.constructor == propertyType.constructor;
    }

    setGenericParameter(genericType: any) {
    }
    abstract verify(): string[];
}

export class VoidType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any) :any{
        return visitor.visitVoidType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export class BooleanType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any) :any{
        return visitor.visitBooleanType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}

export class ServerSideDataLoaderType extends PropertyType {
    
    public set functionName(v: string) { this._functionName = v; } public get functionName(): string { return this._functionName;} private _functionName: string;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;
    
    public Accept(visitor: IPropertyTypeVisitor, parameter: any) :any{
        return visitor.visitServerSideDataLoaderType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export enum DateTypeDefaultValues{
    Empty = 0,
    Now = 1,
    TodayStart = 2,
    TodayEnd = 3,
    
}
export class DateType extends PropertyType {
    constructor(parent:ViewModel) {
        super(parent);
        this.defaultValueType = DateTypeDefaultValues.Empty;
    }
    public set defaultValueType(v: DateTypeDefaultValues) { this._defaultValueType = v; } public get defaultValueType(): DateTypeDefaultValues { return this._defaultValueType;} private _defaultValueType: DateTypeDefaultValues;
    
    public Accept(visitor: IPropertyTypeVisitor, parameter: any) :any{
        return visitor.visitDateType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}


export class IntegerType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitIntegerType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export class FloatType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitFloatType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export class StringType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitStringType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export class ChartSeriesType extends PropertyType{
    public Accept(visitor: IPropertyTypeVisitor, parameter: any) {
        return visitor.visitChartSeriesType(this,parameter);
    }
    verify(): string[] {
        return [];
    }

}
export class ListType extends PropertyType {
    public set OfType(v: PropertyType) { this._OfType = v; } public get OfType(): PropertyType { return this._OfType;} private _OfType: PropertyType;
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitListType(this,parameter);
    }
    setGenericParameter(genericType: any) {
        this.OfType = genericType;
    }

    verify(): string[]{
        let result = [];
        if(this.OfType==null){
            result.push('type is not specified.')
        }else{
            result.push(...this.OfType.verify())
        }
        return result;
    }
}


export class ClassType extends PropertyType {
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitClassType(this,parameter);
    }
    verify(): string[]{
        return [];
    }
}
export class KnownClassType extends ClassType {
    public set ForClass(v: DataModelClass) { this._ForClass = v; } public get ForClass(): DataModelClass { return this._ForClass;} private _ForClass: DataModelClass;
    public Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.visitKnownClassType(this,parameter);
    }
    setGenericParameter(genericType: any) {
        this.ForClass = genericType;
    }
    verify(): string[]{
        let result = [];
        if(this.ForClass==null){
            result.push('class type is not specified.')
        }
        return result;
    }
}


export interface IPropertyTypeVisitor{
    visitDateType(arg0: DateType, parameter: any): any;
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any): any;
    visitVoidType(arg0: VoidType, parameter: any): any;
    visitBooleanType(arg0: BooleanType, parameter: any):any;
    visitIntegerType(arg0: IntegerType, parameter: any):any;
    visitFloatType(arg0: FloatType, parameter: any):any;
    visitStringType(arg0: StringType, parameter: any):any;
    visitListType(arg0: ListType, parameter: any):any;
    visitClassType(arg0: ClassType, parameter: any):any;
    visitKnownClassType(arg0: KnownClassType, parameter: any):any;
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any):any;
}